// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__3Uuyq","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__26pt3"};